import gql from "graphql-tag";

export const createKanban = gql`
  mutation Mutation($data: CreateKanbanInput!) {
    AddKanban(data: $data) {
      flag
      status
      statusId
      title
      url
      userId
    }
  }
`;

export const getKanban = gql`
  query Query($data: GetKanbanInput!) {
    getKanban(data: $data)
  }
`;

export const GET_KANBAN_TEAM_MEMBERS = gql`
  query GetKanbanTeamMembers($projectId: ID!) {
    kanbanTeamMembers(projectId: $projectId) {
      _id
      name
    }
  }
`;

export const updateKanban = gql`
  mutation updateKanban($data: updateKanbanInput!) {
    updateKanbanStatus(data: $data)
  }
`;

export const syncFlag = gql`
  mutation SyncFlag($data: syncFlagInput!) {
    syncFlag(data: $data)
  }
`;

export const updateKanbanTag = gql`
  mutation UpdateKanbanTag($data: updateKanbanTagInput!) {
    UpdateKanbanTag(data: $data)
  }
`;

export const deleteKanbanTag = gql`
  mutation DeleteKanbanTag($data: deleteKanbanTagsInput!) {
    DeleteKanbanTag(data: $data)
  }
`;

export const addKanbanTags = gql`
  mutation AddKanbanTags($data: addKanbanTagsInput!) {
    AddKanbanTags(data: $data)
  }
`;

export const createKanbanColumn = gql`
  mutation Mutation($data: CreateKanbanColumnInput!) {
    CreateKanbanColumn(data: $data)
  }
`;

export const updateKanbanColumn = gql`
  mutation Mutation($data: UpdateKanbanColumnInput!) {
    UpdateKanbanColumn(data: $data)
  }
`;

export const deleteKanbanColumn = gql`
  mutation DeleteKanbanColumn($data: deleteKanbanColumnInput!) {
    DeleteKanbanColumn(data: $data)
  }
`;

export const getIssueById = gql`
  query Query($issueId: String!) {
    GetIssueById(issueId: $issueId)
  }
`;

export const addCommentMutation = gql`
  mutation AddCommentMutation($data: AddCommentMutationInput!) {
    AddCommentMutation(data: $data)
  }
`;
export const updateIssueMutation = gql`
  mutation UpdateIssue($data: UpdateIssueType!) {
    UpdateIssue(data: $data)
  }
`;
export const updateIssueAllMutation = gql`
  mutation UpdateIssueAll($data: UpdateIssueAllInput!) {
    UpdateIssueAll(data: $data)
  }
`;
export const CREATE_KANBAN_TEAM_MEMBER = gql`
  mutation CreateKanbanTeamMember($data: CreateKanbanTeamMemberInput!) {
    createKanbanTeamMember(data: $data)
  }
`;
